<template>
    <div v-bind:class="content || isNew ? 'md:grid md:grid-cols-1 md:gap-6':'md:grid md:grid-cols-2 md:gap-6'">
        <input type="text" v-show="!content && !isNew"
               class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
               id="googleCode" placeholder="2FA Auth Code"
               v-model="code2fa"/>
        <button type="button" v-show="!content && !isNew"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-blue-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                @click="getSecretData(sid, code2fa, reference, vm)">
            Exibir conteúdo seguro
        </button>
        <textarea id="secretContent" v-show="content || isNew"
                  v-model="content"
                  class="form-input rounded-md shadow-sm"
                  @input="$emit('input', content)"
                  ref="textarea">{{content}}</textarea>
    </div>

</template>

<script>
    export default {
        props: ['sid', 'reference', 'value', 'isNew'],
        data() {
            return {
                code2fa: null,
                vm: this,
                content: null
            }
        },
        methods: {
            getSecretData: (sid, code2fa, reference, vm) => {
                axios
                    .get(`/json/secrets/${sid}?code=${code2fa}&reference_table=${reference}`)
                    .then(res => {
                        vm.content = res.data.content || ' ';
                        vm.$forceUpdate();
                    })
                    .catch(error => {
                        alert('Código incorreto. Por favor tente novamente.')
                    });
            },
            focus() {
                this.$refs.input.focus()
            }
        }
    }
</script>

